import { useAuth } from "@/AuthProvider";
import SubHeader from "@/components/SubHeader";
import ToolipsCustom from "@/components/ToolipsCustom";
import defaultValues from "@/constant/defaultValues";
import roles from "@/constant/roles.config";
import { privateRoutePaths } from "@/routes/private.route.config";
import { buildPath, convertUTCToTzDate } from "@/utils/common";
import { isEmpty, map, size } from "lodash";
import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import ImgUpload from "@/assets/images/webp/image-upload.webp";
import { productList } from "@/actions/productAction";
import ButtonAdminpanel from "@/components/ButtonAdminpanel";
import { default as ReactSelect } from "react-select";
import { getCompanyListByTradeMode } from "@/actions/memberAction";

const ProductRequests = (props) => {

    const { user, isPreKYCUser, isDemoUser, isEndUser, isViewer, isAdmin } = useAuth();

    const { BASE_URL } = defaultValues.IMAGE_PATH;

    const [products, setProducts] = useState([]);
    const [tableKey, setTableKey] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [offset, setOffset] = useState(0);
    const [limit, setLimit] = useState(10);
    const [totalProducts, setTotalProducts] = useState(0);
    const [memberList, setMemberList] = useState([]);
    const [selectedMember, setSelectedMember] = useState(null);

    const getPrefix = () => {
        if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
        if (user && isDemoUser) return roles.DEMO.prefix;
        if (user && isEndUser) return roles.END_USER.prefix;
        if (user && isViewer) return roles.VIEWER.prefix;
        return roles.SUPER_ADMIN.prefix;
    };

    const customMemberFilter = (option, searchTxt) =>
        option.data.email.toLowerCase().includes(searchTxt.toLowerCase()) ||
        option.data.label.toLowerCase().includes(searchTxt.toLowerCase());

    const handlePageClick = (event) => {
        const selectedIndex = event.selected + 1;
        const offsetVal = selectedIndex === 1 ? 0 : (selectedIndex - 1) * limit;

        setCurrentPage(event.selected);
        setOffset(offsetVal);
        getProductList(offsetVal, limit, 0);

    };

    const handleMemberInputChange = (val = "") => {
        fetchMembers(val.length >= 3 ? val : "");
    };

    const getProductList = async (ofst, lmt, member) => {
        let reqData = {
            offset: ofst,
            limit: lmt,
            member: member,
            product_status: "2"
        }
        await props.fetchProducts(reqData).then((response) => {
            if (response.status === true) {
                setProducts(response.data)
                let pgCount = Math.ceil(response.metadata.total / response.metadata.limit);
                setPageCount(pgCount);
                setTotalProducts(response.metadata.total);
                // setTableKey(tableKey + 1);
                setTableKey((prev) => prev + 1);
            }
        }).catch((err) => {
            console.log("Error ============ ", err);
        })
    }

    const fetchMembers = async (val) => {
        try {
            const response = await props.getCompanyListByTradeMode("SUPPLIER", val);
            if (response.status === true) {
                setMemberList(
                    map(response.data, (c) => ({
                        value: c.id,
                        label: c.company_list_name,
                        email: c.email,
                    }))
                );
            }
        } catch (err) {
            console.error("getCompanyListByTradeMode error:", err);
        }
    };

    const handleSelectChange = (val) => {
        setSelectedMember(val);
    }

    const resetFilter = () => {
        setSelectedMember(null);
        setOffset(0);
        setLimit(10);
        setCurrentPage(0);
        setTableKey((prev) => prev + 1);
        getProductList(0, 10, 0, "");
    }

    const filterProducts = () => {
        if (selectedMember) {
            setOffset(0);
            setLimit(10);
            setCurrentPage(0);
            let m = 0;
            let p = "";
            if (selectedMember) {
                m = selectedMember.value;
            }

            getProductList(0, 10, m, p);
        }
    }

    useEffect(() => {
        getProductList(offset, limit, 0);
    }, []);

    return (<>
        <div className="container-fluid">

            {
                <SubHeader
                    layer1="Request Management"
                    layer2="Product Requests"
                    layer3=""
                    pageName="Product Requests"
                    clickable={{
                        layer1: "",
                        layer2: "",
                        layer3: "",
                    }}
                />

            }
        </div>

        <div className="container-fluid">
            <div className="row justify-content-between mt-4 mb-3">
                <div className="col-xxl-9 ">
                    <div className="row">
                        <div className="col-xxl-4">
                            <ReactSelect
                                options={memberList}
                                onInputChange={handleMemberInputChange}
                                labelledBy="Select"
                                name="member_id"
                                value={selectedMember}
                                classNamePrefix="react-select"
                                onChange={handleSelectChange}
                                noOptionsMessage={() => "No Company Found"}
                                filterOption={customMemberFilter}
                            />
                        </div>

                        <div className="col-xxl-4  filter-search-btn">
                            <ButtonAdminpanel type="button" onClick={filterProducts} className="btn-regi">
                                <i className="fa-solid fa-magnifying-glass text-white"></i>
                            </ButtonAdminpanel>

                            <button type="button" className=" btn filter-reset-btn" onClick={resetFilter}>
                                <svg viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g fill="none" fillRule="evenodd" stroke="#000000" strokeLinecap="round" strokeLinejoin="round" transform="matrix(0 1 1 0 2.5 2.5)"> <path d="m3.98652376 1.07807068c-2.38377179 1.38514556-3.98652376 3.96636605-3.98652376 6.92192932 0 4.418278 3.581722 8 8 8s8-3.581722 8-8-3.581722-8-8-8"></path> <path d="m4 1v4h-4" transform="matrix(1 0 0 -1 0 6)"></path> </g> </g></svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="col-xxl-3 d-flex justify-content-end">
                </div>
            </div>
            <div className="p-0 border bg-white rounded card-shadow mt-3">
                <h5 className='table-text p-3'>List</h5>

                <div className="table-wrape">
                    <table style={{ width: "100%" }} class="simple-table">
                        <thead>
                            <tr>
                                <th style={{ width: 130 }}>Product</th>
                                <th>Product Name</th>
                                <th>Company Name</th>
                                <th >Price</th>
                                <th >Category</th>
                                <th >Request Date</th>
                                <th>Status</th>
                                <th style={{ width: 80 }}>{!isAdmin && "Actions"}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                size(products) > 0 && map(products, (val) => {
                                    return (<tr key={`product_${val.id}`}>
                                        <td>
                                            <div className="thumb-wrape">
                                                <img src={!isEmpty(val.product_thumb_media) && val.product_thumb_media[0] ? BASE_URL + val.product_thumb_media[0].photo_detail : ImgUpload} alt="" />
                                            </div>
                                        </td>
                                        <td>{val.product_name}</td>
                                        <td>
                                            {val.member_id > 0 ? val.company.company_name : "-"}
                                        </td>
                                        <td>{val.price_type === "fixed" ? val.price + "$ / " + val.price_unit : "Request On Quote"}</td>
                                        {/* <td>Edit | Delete</td> */}
                                        <td>{val.category_id > 0 ? val.category.category_name : "-"}</td>
                                        <td>{val.sent_for_approval_date ? convertUTCToTzDate(val.sent_for_approval_date) : ''}</td>
                                        <td>{val.status === 0 ? 'Draft' : (val.status === 1) ? 'Active' : (val.status === 2) ? 'In Review' : 'Rejected'}</td>
                                        <td>
                                            {(!isAdmin) &&
                                                <Link to={`/${getPrefix()}${buildPath(privateRoutePaths.REQUEST_UPDATE_PRODUCT, { id: val.id })}`}>
                                                    <ToolipsCustom subtitle="Edit" className="fa-regular fa-pen-to-square icon-pen border-0 panle-icon " classNameChild={"data-table-tooltiop"}></ToolipsCustom>
                                                </Link>
                                            }
                                        </td>
                                    </tr>)
                                })
                            }
                            {
                                size(products) <= 0 && <tr>
                                    <td colSpan={8}>
                                        No Data Found.
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>

                <div className="d-flex justify-content-between inquiry-pagination p-4 pb-2">
                    <ReactPaginate
                        key={tableKey}
                        forcePage={currentPage}
                        nextLabel=">"
                        onPageChange={handlePageClick}
                        pageRangeDisplayed={2}
                        marginPagesDisplayed={2}
                        pageCount={pageCount}
                        previousLabel="<"
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        breakLabel="..."
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        containerClassName="pagination"
                        activeClassName="active"
                        renderOnZeroPageCount={null}
                    />
                </div>
            </div>

        </div >
    </>)
}

const mapStateToProps = (state) => {
    return {}
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchProducts: (reqData) => dispatch(productList(reqData)),
        getCompanyListByTradeMode: (trade_mode, searchTxt) => dispatch(getCompanyListByTradeMode(trade_mode, searchTxt)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductRequests);